import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Star, Users } from 'lucide-react';

export function TestimonialsSection({ content, theme, t }) {
  return (
    <section key="testimonials" id="testimonials" data-section="testimonials" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          {content.testimonials_heading?.badge && (
            <Badge className="bg-[#007a33] text-white border-[#007a33] mb-4 px-4 py-1 hover:bg-[#007a33] text-[0.7rem] font-black tracking-[1px]">
              {content.testimonials_heading.badge}
            </Badge>
          )}
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">{content.testimonials_heading?.title || 'Loved by Grassroots Coaches'}</h2>
          <p className={`${t.textSecondary} text-lg`}>{content.testimonials_heading?.subtitle || 'See what coaches are saying about Grassroots Coaching'}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {content.testimonials?.map((testimonial, index) => (
            <Card key={testimonial.id || index} className={t.card}>
              <CardContent className="p-6">
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating || 5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>
                <p className={`${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'} mb-6 leading-relaxed`}>"{testimonial.text}"</p>
                <div className="flex items-center gap-3">
                  {testimonial.avatar ? (
                    <img
                      src={testimonial.avatar.startsWith('/api') ? `${process.env.REACT_APP_BACKEND_URL}${testimonial.avatar}` : testimonial.avatar}
                      alt={testimonial.author || 'Quote author'}
                      className="w-10 h-10 object-contain shrink-0"
                      loading="lazy"
                      decoding="async"
                    />
                  ) : (
                    <div className={`w-10 h-10 rounded-full ${theme === 'dark' ? 'bg-[#007a33]/20' : 'bg-[#007a33]/10'} flex items-center justify-center`}>
                      <Users className={`w-5 h-5 ${t.accentText}`} />
                    </div>
                  )}
                  <div>
                    <p className={`font-semibold ${t.text}`}>{testimonial.author}</p>
                    <p className={`text-sm ${t.textMuted}`}>{testimonial.role}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
